import client from './client';
import { Order, ProductOrderHistoryDetail } from '../types';

const mapOrders = <T extends Order = Order>(orders: any[]): T[] =>
  orders.map((order: any) => ({
    ...order,
    storeName: order.store?.name || 'Unknown Store',
    date: new Date(order.createdAt).toLocaleString('ko-KR'),
  })) as T[];

export const getSellerCustomerHistoryDetail = async (params: {
  customerName?: string;
  customerPhone?: string;
  userId?: string;
  orderSheetId?: string;
}): Promise<Order[]> => {
  const response = await client.get('seller-page-details/customer-history', {
    params,
  });
  return mapOrders(response.data);
};

export const getSellerProductHistoryDetail = async (params: {
  productId: string;
  productOptionId?: string;
  orderSheetIds?: string[];
}): Promise<ProductOrderHistoryDetail[]> => {
  const response = await client.get('seller-page-details/product-history', {
    params: {
      productId: params.productId,
      productOptionId: params.productOptionId,
      orderSheetIds: params.orderSheetIds?.join(','),
    },
  });
  return mapOrders<ProductOrderHistoryDetail>(response.data);
};

export interface ProductCancelledHistoryRow {
  orderId: string;
  customerName: string;
  customerPhone: string | null;
  cancelledQty: number;
  cancelledAt: string;
  request: string | null;
}

export const getSellerProductCancelledHistory = async (params: {
  productId: string;
  productOptionId?: string;
  orderSheetIds?: string[];
}): Promise<ProductCancelledHistoryRow[]> => {
  const response = await client.get(
    'seller-page-details/product-cancelled-history',
    {
      params: {
        productId: params.productId,
        productOptionId: params.productOptionId,
        orderSheetIds: params.orderSheetIds?.join(','),
      },
    },
  );
  return response.data;
};
